module.exports = __webpack_public_path__ + "static/media/f_lipshape_thin.d0e72c04.png";